export enum AdditionalFilters {
  None = 0,
  Subgroups = 1
}
